<template>
  <div
    v-if="badge"
    class="product-badges"
    :style="{ backgroundColor: badge.badge_colour }"
  >
    <span
      class="
        product-badges__text
        text-body-xs-bold
      "
      :style="{ color: badge.text_colour }"
      v-text="badge.badge_text"
    />
  </div>
</template>

<script>

/**
 * Vue: Product badges (product-badges)
 * -----------------------------------------------------------------------------
 * Product badges.
 *
 * @param {Object} badges - Product badges.
 * @param {Object} product - Local product object.
 *
 */
export default {
  name: 'ProductBadges',

  props: {
    badges: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  computed: {

    /**
     * Compute product badge.
     * @returns {Object}
     */
    badge() {
      return this.badges.find((badge) => {
        return this.product.tags.includes(badge.badge_tag)
      })
    },
  },
}
</script>

<style lang="scss">
@import './product-badges';
</style>
